import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { SidebarItemComponent } from '../../molecules/sidebar-item/sidebar-item.component';
import { MobileSidebarService } from '../../../../core/services/mobile-sidebar.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthState } from '../../../../core/state/auth/auth.reducer';
import { Store } from '@ngrx/store';
import { logoutBackend } from '../../../../core/state/auth/auth.actions';
import { Observable } from 'rxjs';
import { selectIsAdmin, selectIsAdminOrModerator, selectIsChef } from '../../../../core/state/user/user.selectors';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackDialogComponent } from '../../molecules/feedback-dialog/feedback-dialog.component';
import { createFeedback } from '../../../../core/state/feedback/feedback.actions';
import { selectIsLoggedIn } from '../../../../core/state/auth/auth.selectors';

@Component({
  selector: 'app-mobile-sidebar',
  imports: [CommonModule, SidebarItemComponent],
  templateUrl: './mobile-sidebar.component.html',
  styleUrl: './mobile-sidebar.component.scss'
})
export class MobileSidebarComponent implements OnInit {

  private store = inject(Store);
  private dialog = inject(MatDialog);
  public isAdmin$: Observable<boolean>;
  public isAdminOrModerator$: Observable<boolean>;
  public isChef$: Observable<boolean>;
  public isLoggedIn$: Observable<boolean>;

  constructor(public mobileSidebar: MobileSidebarService, private router: Router, private authStore: Store<AuthState>) {}

  isOpen = false;

  ngOnInit() {
    this.mobileSidebar.isSidebarOpen$.subscribe(open => {
      this.isOpen = open;
    });

    // Close sidebar on route change
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.mobileSidebar.close(), 100); // 100ms delay
        this.mobileSidebar.close();
      }
    });

    this.isAdmin$ = this.authStore.select(selectIsAdmin);
    this.isAdminOrModerator$ = this.authStore.select(selectIsAdminOrModerator);
    this.isChef$ = this.authStore.select(selectIsChef);
    this.isLoggedIn$ = this.authStore.select(selectIsLoggedIn)
  }

  close() {
    this.mobileSidebar.close();
  }

  logout() {
    this.authStore.dispatch(logoutBackend());
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
  }

  openFeedbackDialog(): void {
    this.mobileSidebar.close();
    const dialogRef = this.dialog.open(FeedbackDialogComponent, {
      width: '500px'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(createFeedback({ feedback: result }));
      }
    });
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.mobileSidebar.close();
  }

  private startX: number | null = null;

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    if (event.touches.length === 1) {
      this.startX = event.touches[0].clientX;
    }
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    if (!this.startX || event.touches.length !== 1) return;

    const currentX = event.touches[0].clientX;
    const deltaX = currentX - this.startX;

    if (deltaX > 50) {
      // Swipe left
      this.mobileSidebar.close();
      this.startX = null;
    }
  }


}
